module.exports = __webpack_public_path__ + "img/pa.26e0ffa1.svg";